export {default as dispatch} from "./dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = 189
// module chunks = 0 1 2 3 4